import React, { useEffect, useState } from 'react';
import '../styles/Welcome.css';
import { Header, Footer, Button } from '../components';
import { checkOnAuthStateChanged, recordEvent } from '../functions';
import { useNavigate } from 'react-router-dom';
import { Arrow } from '../assets/icons';
import { colour } from '../styles/GlobalStyles';

function Welcome() {
    const [loggedIn, setLoggedIn] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "Welcome | Clozers";
        const fetchUserData = async() => {
            const user = await checkOnAuthStateChanged();
            if ( user.status === 200 ) {
                setLoggedIn(true);
            }
            else {
                setLoggedIn(false);
                navigate("/");
            }
        };
        fetchUserData();
        
    }, [navigate]);

    const viewSample = () => {
        recordEvent("view_sample_report", {});
        navigate("/sample-report");
    };

     const bookDemo = () => {
        recordEvent("book_demo", {});
        window.open("https://calendly.com/liam-maher/clozers-demo", "_blank");
    };

    return (
        <div className="welcome-outer-container">
            <Header
                loggedIn={loggedIn}
            />
            <div className="welcome-inner-container">
                <h1 className="heading-large-bold colour-primary text-align-center">
                    Welcome to Clozers!
                </h1>
                <span className="body-regular colour-primary block-text text-align-center">
                    To get started, we'll show you a sample report.
                </span>
                <div className="welcome-button-container">
                    <Button
                        buttonType="primary-button"
                        size="large"
                        text={"See sample report"}
                        cta={viewSample}
                        disabled={false}
                        leftIcon={null}
                        leftIconClass=""
                        rightIcon={<Arrow className="reverse" fill={colour.gray00} />}
                        rightIconClass=""
                        alt=""
                        standardIcon={false}
                        badge={false}
                        badgeVal={null}
                        badgeBG={null}
                        buttonRef={null}
                        spinner={false}
                    />
                </div>
                <div className="welcome-demo-container">
                    <span className="body-regular colour-secondary">
                        Want a quick demo?
                    </span>
                    <div 
                        className="text-button button-row gap-x-small"
                        onClick={() => bookDemo()}
                    >
                        <span className="body-regular colour-primary">
                            Book demo
                        </span>
                        <Arrow className="welcome-demo-arrow" fill={colour.gray06} />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
};

export default Welcome;